// extracted by mini-css-extract-plugin
export default {"padding-right":"g__padding-right--t60cZ","purchase-agreement-row":"g__purchase-agreement-row--_NN5q","divider":"g__divider--Jq3kE"};